import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";
import { supabase } from "../../config/Supabase";
import HerbMonograph from "./HerbMonograph";
import { herbSlug } from "../../utils/herbSlug";

// Public, indexable herb monograph at /herbs/:slug. Resolves the keyword slug to a
// herb (herb titles are effectively unique in a materia medica), then renders the
// shared HerbMonograph. Prerendered at build + listed in the sitemap.
const HerbPage = () => {
  const { slug } = useParams();
  const [herb, setHerb] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let active = true;
    (async () => {
      setStatus("loading");
      // Resolve slug -> id via the lightweight title list (no slug column needed).
      const { data: list, error: listErr } = await supabase.from("herbs").select("id,title");
      if (!active) return;
      if (listErr || !list) {
        setStatus("notfound");
        return;
      }
      const match = list.find((h) => herbSlug(h) === slug);
      if (!match) {
        setStatus("notfound");
        return;
      }
      const { data, error } = await supabase.from("herbs").select("*").eq("id", match.id).single();
      if (!active) return;
      if (error || !data) {
        setStatus("notfound");
        return;
      }
      setHerb(data);
      setStatus("ok");
    })();
    return () => {
      active = false;
    };
  }, [slug]);

  if (status === "loading") {
    return (
      <Container className="d-flex justify-content-center" style={{ padding: "140px 0" }}>
        <Spinner animation="border" />
      </Container>
    );
  }
  if (status === "notfound" || !herb) {
    return (
      <div style={{ padding: "140px 20px", textAlign: "center" }}>
        <h1>Herb not found</h1>
        <p>
          Browse the <Link to="/herbCategories">herb library</Link>.
        </p>
      </div>
    );
  }

  return <HerbMonograph herb={herb} indexable={true} />;
};

export default HerbPage;
